/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const exportEntries = {
  exportToCsv: 'Exportar para CSV',
  exportMessage:
    'O arquivo CSV será baixado automaticamente para o seu dispositivo, caso contrário, verifique as configurações do seu navegador',
  columnNúmeros: {
    code: 'Código',
    quantity: 'Quantidade',
    name: 'Nome',
    price: 'Preço',
  },
  exportProductToCsv: 'Exportar produto para CSV',
};

export const importEntries = {
  importProducts: 'Importação de carrinhos salvos',
};

export const importEntriesDialog = {
  fileUploaded: 'Dados importados com sucesso',
  importProductsRulesTitle: 'Importar produtos para seus carrinhos salvos a partir de um arquivo .xlsx',
  importProductsFirstRule: 'Quantidade, Tipo de Pacotes, Peso, Grupo, Qualidade, Dimensões, Certificados',
  importProductsSecondRule: 'Tamanho máximo do arquivo: 976 KB',
  importProductsSubtitle: 'O arquivo importado será usado para criar um novo carrinho que você poderá consultar na seção Minha Conta / Carrinhos Salvos.',
  importProductFileDetails:
    'Selecione o arquivo para carregar. Primeiro, você deve baixar o arquivo para preencher: ',
  importProductClickHere: 'Clique aqui',
  importProductFileDetailsFinal: 'para baixar o arquivo',
  importProducts: 'Importação de carrinhos salvos',
  importProductsNewSavedCartSubtitle:
    'Adicione produtos importando um arquivo . CSV.and creating a new saved cart.',
  selectFile: 'Selecione o arquivo',
  savedCartNumber: 'Número do carrinho salvo',
  savedCartDescription: 'Descrição do carrinho salvo',
  opcional: 'opcional',
  charactersLeft: 'Caracteres à esquerda: {{count}}',
  cancel: 'Cancelar',
  upload: 'Importar',
  close: 'Fechar',
  summary: {
    info: 'Não feche ou atualize esta janela enquanto os produtos estiverem sendo importados.',
    loadedToCart: 'Os produtos foram carregados no carrinho {{ cartName }}',
    loaded: 'Os produtos foram carregados',
    loading: 'Products are being processed... ({{ count }}/{{ total }})',
    successes:
      '{{ successesCount }} de {{ total }} Os produtos foram importados com sucesso.',
    warning: 'O produto não foi importado na sua totalidade.',
    warning_other: '{{ count }} Os produtos não foram importados na sua totalidade.',
    error: '{{ count }} O produto não foi importado.',
    error_other: '{{ count }}Os produtos não foram importados.',
    messages: {
      unknownIdentifier: 'Product SKU "{{ productCode}}" does not exist.',
      lowStock:
        'Quantidade para {{ productName }}: {productName}} se ha reducido a {{ quantityAdded }}.',
      noStock: '{{ productName }} está esgotado no momento.',
      unknownError: 'Unrecognized problem with "{{ productCode }}".',
      limitExceeded: 'Can not add "{{ productCode }}". Limit exceeded.',
    },
    show: 'Programa',
    hide: 'Esconder',
  },
};

export const importExport = {
  exportEntries,
  importEntries,
  importEntriesDialog,
};
